<template lang="pug">
div
  Form(:data="crime", :isSubmitting="isSubmitting", :isEdit="true", @submit="update")
</template>

<script>
import { onMounted } from '@vue/composition-api'
import Form from '../shared/Form.vue'
import useCrimeEdit from './useCrimeEdit'

export default {
  components: {
    Form,
  },

  setup() {
    const { show, update, crime, isSubmitting } = useCrimeEdit()

    onMounted(show)

    return {
      crime,
      update,
      isSubmitting,
    }
  },
}
</script>
